module.exports = __webpack_public_path__ + "img/related.119a75b5.png";